<bn-account-detail-base [product]="product"
                        [hostRef]="hostRef"
                        [productNumberFormat]="productNumberFormat"
                        [title1]="title1"
                        [title2]="title2"
                        [title3]="title3">
  <div details>
    <div class="account-detail-base__item">
      <div>
        <strong i18n="@@product.details.availableBalance">Available balance</strong>
      </div>
      <div>{{ product?.availableBalance | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
    </div>
    <div class="account-detail-base__item">
      <div>
        <strong i18n="@@product.details.totalBalance">Total balance</strong>
      </div>
      <div>{{ product?.additions?.totalBalance | bnCurrencyPipe:product?.additions?.currencyCode  }}</div>
    </div>
  </div>

  <div row2
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.inTransit">In transit</strong></div>
        <div>{{ product?.additions?.deferredBalance | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.startDate">Start date</strong></div>
        <div>{{ product?.accountOpeningDate == -1 ? '--' : product?.accountOpeningDate | bnEsDate }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.withheld">Withheld</strong></div>
        <div>{{ product?.additions?.retainedBalance | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.accountStatus">Account status</strong>
        </div>
        <div>{{ product?.additions?.accountStatus == -1 ? '--' : product?.additions?.accountStatus }}</div>
      </div>
    </div>
  </div>

  <div row3
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.accountManager">Account manager</strong>
        </div>
        <div>{{ product?.additions?.accountOfficialName == -1 ? '--' : product?.additions?.accountOfficialName }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.regionalAccountNumber">Regional account number</strong>
        </div>
        <div>{{ product?.additions?.regionalCode == -1 ? '--' : product?.additions?.regionalCode }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.accountBranch">Account branch</strong>
        </div>
        <div>{{ product?.bankBranchCode == -1 ? '--' : product?.bankBranchCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.interestRate">Interest rate</strong>
        </div>
        <div *ngIf="product?.accountInterestRate != -1">{{ product?.accountInterestRate }}%</div>
        <div *ngIf="product?.accountInterestRate == -1">--</div>
      </div>
    </div>
  </div>

</bn-account-detail-base>
